"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConstructionRoofingType = void 0;
var ConstructionRoofingType;
(function (ConstructionRoofingType) {
    ConstructionRoofingType["COMPOSITION_SHINGLE"] = "COMPOSITION_SHINGLE";
    ConstructionRoofingType["ARCHITECTURAL_SHINGLE"] = "ARCHITECTURAL_SHINGLE";
    ConstructionRoofingType["COMPOSITION_OVER_WOOD"] = "COMPOSITION_OVER_WOOD";
    ConstructionRoofingType["METAL"] = "METAL";
    ConstructionRoofingType["SLATE"] = "SLATE";
    ConstructionRoofingType["PLEXIGLASS"] = "PLEXIGLASS";
    ConstructionRoofingType["WOOD"] = "WOOD";
    ConstructionRoofingType["TILE"] = "TILE";
    ConstructionRoofingType["TAR_AND_GRAVEL"] = "TAR_AND_GRAVEL";
    ConstructionRoofingType["ROLL"] = "ROLL";
    ConstructionRoofingType["RUBBER"] = "RUBBER";
    ConstructionRoofingType["PLASTIC"] = "PLASTIC";
    ConstructionRoofingType["FIBERGLASS"] = "FIBERGLASS";
    ConstructionRoofingType["FOAM"] = "FOAM";
    ConstructionRoofingType["ALL_OTHER"] = "ALL_OTHER";
})(ConstructionRoofingType = exports.ConstructionRoofingType || (exports.ConstructionRoofingType = {}));
